import { render, staticRenderFns } from "./HeatingSystemHealth.global.vue?vue&type=template&id=ef825bfc&lang=pug&"
import script from "./HeatingSystemHealth.global.vue?vue&type=script&lang=ts&"
export * from "./HeatingSystemHealth.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports